import './App.css';
import { useRef, useState } from 'react';
import ModelViewer from './Components/ModelViewer/ModelViewer';
import Onboarding from './Components/Onboarding/Onboarding'
import MuteToggleButton from './Components/MuteToggleButton/MuteToggleButton';
import ARButton from './Components/ARButton/ARButton';
import QRCodeModal from './Components/QRCodeModal/QRCodeModal';
import HelpButton from './Components/HelpButton/HelpButton';
import AudioTrack from "../src/media/Engine_TreeLoop_Test.mp3"



function App() {
  const modelViewerUrl = `https://reybeam.reydar.com/?config_uuid=c9aa7ee1-93f2-4fdc-8180-75142493b738`
  const handoffUrl = `https://feelgoodchristmas.reydar.com/?handoff`
  const fallbackUrl = `https://feelgoodchristmas.reydar.com`
  const glbFileUrl = `https://cdn.enginecloud.co.uk/models/986eb824-be7b-4cce-b6ea-b1e20fea92b4/39d73778-f888-4056-9955-15f281de01d2.glb`
  const usdzFileUrl = `https://cdn.enginecloud.co.uk/models/986eb824-be7b-4cce-b6ea-b1e20fea92b4/39d73778-f888-4056-9955-15f281de01d2.usdz`


  const audioPlayer = useRef(document.querySelector(".audio-player"));
  const [helpScreenVisible, setHelpScreenVisible] = useState(false);
  const [qrCodeModalVisible, setQRCodeModalVisible] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  const toggleMute = () => {
    logToggleMuteButtonClicked();
    setIsMuted(!isMuted);
    audioPlayer.current.muted = !isMuted;
    
    if (!isAudioPlaying){
      playAudio();
      setIsAudioPlaying(true)
    }
  }
  
  const logHelpButtonClicked = () => {
    //eslint-disable-next-line
    gtag('event', 'click', {'event_category': 'button', 'event_label': 'help_button'});
  }
  const logArButtonClickedDesktop = () => {
    //eslint-disable-next-line
    gtag('event', 'click', {'event_category': 'button', 'event_label': 'ar_button_desktop'});
  }
  const logArButtonClickedMobile = () => {
    //eslint-disable-next-line
    gtag('event', 'click', {'event_category': 'button', 'event_label': 'ar_button_mobile'});
  }
  const logToggleMuteButtonClicked = () => {
    //eslint-disable-next-line
    gtag('event', 'click', {'event_category': 'button', 'event_label': 'toggle_mute_button'});
  }

  const playAudio = () => {
    audioPlayer.current.play();
    //eslint-disable-next-line
    gtag('event', 'click', {'event_category': 'button', 'event_label': 'play_audio'});
  }
  
  return (
    <div className="App">
      <audio ref={audioPlayer} src={AudioTrack} loop={true} className="hidden audio-player"></audio>
      <ModelViewer modelViewerUrl={modelViewerUrl}/>
      <HelpButton setHelpScreenVisible={setHelpScreenVisible} logHelpButtonClicked={logHelpButtonClicked}/>
      <MuteToggleButton isMuted={isMuted} toggleMute={toggleMute} playAudio={playAudio}/>
      <ARButton 
      setQRCodeModalVisible={setQRCodeModalVisible}
      logArButtonClickedDesktop={logArButtonClickedDesktop} 
      logArButtonClickedMobile={logArButtonClickedMobile}
      fallbackUrl={fallbackUrl}
      glbFileUrl={glbFileUrl}
      usdzFileUrl={usdzFileUrl}
      ></ARButton>
      {qrCodeModalVisible && <QRCodeModal handoffUrl={handoffUrl} setQRCodeModalVisible={setQRCodeModalVisible}></QRCodeModal>}
      {helpScreenVisible && <Onboarding
      setHelpScreenVisible={setHelpScreenVisible} 
      />}
    </div>
  );
}

export default App;
